/*
  Triggers the count-strip "bump" animation on the cart icon when the item
  count actually changes.

  Dawn re-renders the #cart-icon-bubble fragment wholesale via the section
  rendering API on every cart update (add, remove, quantity change), which
  means the DOM node is replaced, not mutated in place — a plain CSS
  transition between old and new state has nothing to animate between. A
  MutationObserver sidesteps that: it doesn't care how the content changed,
  only that it did, so it works the same way regardless of which code path
  (drawer, cart page, quick add) triggered the update.
*/
(function () {
  var lastCount = null;

  function currentCount() {
    var el = document.querySelector('[data-idz-cart-count] [aria-hidden="true"]');
    if (!el) return null;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? null : n;
  }

  function bump() {
    var strip = document.querySelector('[data-idz-cart-count]');
    if (!strip) return;
    strip.classList.remove('idz-cart-bump');
    // Force reflow so the animation restarts if it fires twice in quick
    // succession (e.g. two rapid quantity clicks).
    void strip.offsetWidth;
    strip.classList.add('idz-cart-bump');
  }

  function check() {
    var count = currentCount();
    if (count === null) return;
    if (lastCount !== null && count !== lastCount) {
      bump();
    }
    lastCount = count;
  }

  check();

  var target = document.querySelector('#cart-icon-bubble') || document.body;
  new MutationObserver(check).observe(target, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
